import { common } from "lobbie";
import { notify, sendToSentry } from "src/utils";

export const handleBackendHttpError = (error: any) => {
    // Check if it's an axios error with our custom HttpError response
    if (error?.response?.data) {
        const httpError = error.response.data as common.IHttpErrorResponse;
        // If we have a structured HttpError response
        if (httpError.userAlertMessage) {
            notify({
                level: httpError.userAlertLevel,
                title: httpError.userAlertTitle,
                message: httpError.userAlertMessage,
            });
            // Log to Sentry if needed
            if (httpError.logToSentry) {
                sendToSentry({ error });
            }
            return {
                error: httpError.userAlertMessage,
                uniqueErrorCode: httpError.uniqueErrorCode,
                status: httpError.status,
            };
        }
    }
    // Handle generic 500 errors
    if (error?.response?.status >= 500) {
        const message = "Something went wrong because of us. Sit tight, we're investigating.";
        notify({
            level: "error",
            title: "Error",
            message,
        });
        sendToSentry({ error });
        return { error: message, status: error.response.status };
    }
    // Handle other errors
    const message = error?.message || "An unexpected error occurred";
    notify({
        level: "error",
        title: "Error",
        message,
    });
    return { error: message };
};
